var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("场景设置")))])]), _c("div", {
    staticClass: "content"
  }, [_c("a-form-model", {
    ref: "dataFrom",
    attrs: {
      model: _vm.form,
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 16
      },
      rules: _vm.dataRule
    }
  }, [_c("a-row", {
    staticStyle: {
      display: "flex",
      "flex-wrap": "wrap"
    }
  }, [_c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("客户名称"),
      prop: "customerId"
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("客户名称"),
      "show-search": "",
      "option-filter-prop": "children",
      "filter-option": _vm.filterOption
    },
    on: {
      change: _vm.customerIdChange
    },
    model: {
      value: _vm.form.customerId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "customerId", $$v);
      },
      expression: "form.customerId"
    }
  }, _vm._l(_vm.customersList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("适用架构"),
      prop: "structureType"
    }
  }, [_c("div", {
    staticStyle: {
      display: "flex"
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "50%"
    },
    attrs: {
      placeholder: _vm.structureTypePlaceholder,
      disabled: !_vm.form.customerId
    },
    on: {
      change: _vm.structureTypeChange
    },
    model: {
      value: _vm.form.structureType,
      callback: function ($$v) {
        _vm.$set(_vm.form, "structureType", $$v);
      },
      expression: "form.structureType"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: "ALL"
    }
  }, [_vm._v(_vm._s(_vm.$t("全部")))]), _c("a-select-option", {
    attrs: {
      value: "DIVISION"
    }
  }, [_vm._v(_vm._s(_vm.$t("部门")))]), _c("a-select-option", {
    attrs: {
      value: "PERSONNEL"
    }
  }, [_vm._v(_vm._s(_vm.$t("人员")))])], 1), _c("a-tree-select", {
    staticClass: "account-tree-class",
    staticStyle: {
      "margin-left": "10px",
      width: "50%"
    },
    attrs: {
      showSearch: "",
      multiple: "",
      maxTagCount: 1,
      treeDefaultExpandAll: true,
      "dropdown-style": {
        maxHeight: "400px",
        maxWidth: "256px",
        overflow: "auto"
      },
      disabled: !_vm.form.customerId || !_vm.form.structureType || _vm.form.structureType === "ALL",
      treeNodeFilterProp: "title",
      "tree-data": _vm.form.structureType === "DIVISION" ? _vm.structureList : _vm.structureListTree
    },
    on: {
      change: _vm.associationIdChange
    },
    model: {
      value: _vm.form.associationId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "associationId", $$v);
      },
      expression: "form.associationId"
    }
  })], 1)])], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("消息类别"),
      prop: "messageCategory"
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.messageCategoryPlaceholder,
      disabled: !_vm.form.customerId
    },
    on: {
      change: _vm.flowTypeIdChange
    },
    model: {
      value: _vm.form.messageCategory,
      callback: function ($$v) {
        _vm.$set(_vm.form, "messageCategory", $$v);
      },
      expression: "form.messageCategory"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: "AUDIT_FLOW"
    }
  }, [_vm._v(_vm._s(_vm.$t("审核流相关")))]), _c("a-select-option", {
    attrs: {
      value: "INSURE"
    }
  }, [_vm._v(_vm._s(_vm.$t("投保相关")))]), _c("a-select-option", {
    attrs: {
      value: "TASK_LIST"
    }
  }, [_vm._v(_vm._s(_vm.$t("任务列表相关")))]), _c("a-select-option", {
    attrs: {
      value: "SURRENDER_INSURANCE"
    }
  }, [_vm._v(_vm._s(_vm.$t("退保相关")))])], 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("推送场景"),
      prop: "pushScenario"
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.pushScenarioPlaceholder,
      disabled: !_vm.form.messageCategory
    },
    on: {
      change: _vm.pushScenarioChange
    },
    model: {
      value: _vm.form.pushScenario,
      callback: function ($$v) {
        _vm.$set(_vm.form, "pushScenario", $$v);
      },
      expression: "form.pushScenario"
    }
  }, _vm._l(_vm.pushScenarioList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.pushScenario
      }
    }, [_vm._v(_vm._s(_vm.$t(item.pushScenarioName)))]);
  }), 1)], 1)], 1)], 1)], 1)], 1), _vm.form.pushScenario ? _c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("事件配置")))])]) : _vm._e(), _vm.form.pushScenario ? _c("div", {
    staticStyle: {
      display: "block"
    }
  }, [_c("a-form-model", {
    ref: "form1",
    attrs: {
      model: _vm.form1,
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 16
      },
      rules: _vm.form1Rule
    }
  }, [_c("a-row", {
    staticStyle: {
      display: "flex",
      "flex-wrap": "wrap"
    }
  }, [_vm.isAuditFlow ? _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("审核流名称"),
      prop: "auditFlowId"
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("审核流名称"),
      allowClear: "",
      "show-search": "",
      "option-filter-prop": "children",
      "filter-option": _vm.filterOption
    },
    on: {
      change: _vm.auditFlowIdChange
    },
    model: {
      value: _vm.form1.auditFlowId,
      callback: function ($$v) {
        _vm.$set(_vm.form1, "auditFlowId", $$v);
      },
      expression: "form1.auditFlowId"
    }
  }, _vm._l(_vm.auditFlowList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_vm._v(" " + _vm._s(item.name === "全部" ? _vm.$t("全部") : item.name) + " ")]);
  }), 1)], 1)], 1) : _vm._e(), _vm.isAuditFlow && _vm.form1.auditFlowId && _vm.form1.auditFlowId !== "ALL" ? _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("审核流节点"),
      prop: "auditFlowNodeId"
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("审核流节点"),
      allowClear: "",
      "show-search": "",
      mode: "multiple",
      "option-filter-prop": "children",
      disabled: _vm.form1.auditFlowId === "ALL",
      "filter-option": _vm.filterOption
    },
    on: {
      change: _vm.auditFlowNodeIdChange
    },
    model: {
      value: _vm.form1.auditFlowNodeId,
      callback: function ($$v) {
        _vm.$set(_vm.form1, "auditFlowNodeId", $$v);
      },
      expression: "form1.auditFlowNodeId"
    }
  }, _vm._l(_vm.auditNodeLists, function (item, index) {
    return _c("a-select-option", {
      key: index + item.name,
      attrs: {
        value: item.id
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 1)], 1)], 1) : _vm._e(), _vm.form.messageCategory && (_vm.form.messageCategory === "INSURE" || _vm.form.messageCategory === "SURRENDER_INSURANCE") ? _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("产品名称"),
      prop: "insuranceId"
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("产品名称"),
      allowClear: "",
      "show-search": "",
      "option-filter-prop": "children",
      "filter-option": _vm.filterOption
    },
    model: {
      value: _vm.form1.insuranceId,
      callback: function ($$v) {
        _vm.$set(_vm.form1, "insuranceId", $$v);
      },
      expression: "form1.insuranceId"
    }
  }, _vm._l(_vm.productList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_vm._v(" " + _vm._s(item.name === "全部" ? _vm.$t("全部") : item.name) + " ")]);
  }), 1)], 1)], 1) : _vm._e()], 1), _c("a-row", [_c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("接收对象")
    }
  }, _vm._l(_vm.receiverConfig[_vm.form.messageCategory], function (receiveItem) {
    return _c("div", {
      key: receiveItem.formKey,
      staticStyle: {
        display: "flex",
        "margin-bottom": "10px"
      }
    }, [_c("a-button", {
      staticClass: "marginR15",
      attrs: {
        type: receiveItem.btnCheck ? "primary" : "default"
      },
      on: {
        click: function ($event) {
          return _vm.changeCheck(receiveItem);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.$t(receiveItem.btnName)) + " ")]), receiveItem.hasSelect ? _c("a-select", {
      staticStyle: {
        "margin-left": "10px"
      },
      attrs: {
        placeholder: _vm.$t("请选择") + _vm.$t("系统内账号"),
        allowClear: "",
        "show-search": "",
        mode: receiveItem.mode,
        disabled: receiveItem.btnCheck,
        "option-filter-prop": "children",
        "filter-option": _vm.filterOption
      },
      model: {
        value: receiveItem.selectValue,
        callback: function ($$v) {
          _vm.$set(receiveItem, "selectValue", $$v);
        },
        expression: "receiveItem.selectValue"
      }
    }, _vm._l(receiveItem.selectOptions, function (item, index) {
      return _c("a-select-option", {
        key: index,
        attrs: {
          value: item.id
        }
      }, [_vm._v(" " + _vm._s(_vm.$t(item.name)) + " ")]);
    }), 1) : _vm._e()], 1);
  }), 0)], 1)], 1), _c("p", [_vm._v(" " + _vm._s(_vm.$t("自定义接收对象")) + " ")]), _c("a-row", [_c("a-col", {
    attrs: {
      span: 18
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("系统内账号"),
      prop: "usersId"
    }
  }, [_c("el-cascader", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("系统内账号"),
      options: _vm.computedAccountTreeData,
      props: _vm.props,
      filterable: "",
      "popper-class": "scene_message",
      "collapse-tags": "",
      clearable: "",
      getPopupContainer: triggerNode => triggerNode.parentNode
    },
    on: {
      change: _vm.changeAccount
    },
    model: {
      value: _vm.form1.usersId,
      callback: function ($$v) {
        _vm.$set(_vm.form1, "usersId", $$v);
      },
      expression: "form1.usersId"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("自定义手机号"),
      prop: "mobile"
    }
  }, [_c("a-textarea", {
    staticClass: "textarea",
    attrs: {
      placeholder: _vm.$t("请输入接收对象的手机号，多个手机号之间用“;（英文）”隔开，国际手机号请输入区号，不输入则默认为+86")
    },
    model: {
      value: _vm.form1.mobile,
      callback: function ($$v) {
        _vm.$set(_vm.form1, "mobile", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "form1.mobile"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("自定义邮箱"),
      prop: "email"
    }
  }, [_c("a-textarea", {
    staticClass: "textarea",
    attrs: {
      placeholder: _vm.$t("请输入邮箱，多个数据之间用“；（英文）”分隔")
    },
    model: {
      value: _vm.form1.email,
      callback: function ($$v) {
        _vm.$set(_vm.form1, "email", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "form1.email"
    }
  })], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm.form.pushScenario ? _c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("消息配置")))])]) : _vm._e(), _vm.form.pushScenario ? _c("div", {
    staticClass: "message-config"
  }, [_c("a-row", [_c("a-col", {
    attrs: {
      span: 24
    }
  }, [_c("a-form-item", {
    staticStyle: {
      display: "flex"
    },
    attrs: {
      label: _vm.$t("接收方式"),
      prop: "sceneConfigId",
      required: ""
    }
  }, [_c("a-checkbox-group", {
    attrs: {
      name: "checkboxgroup",
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 16
      }
    },
    on: {
      change: _vm.onChange
    },
    model: {
      value: _vm.sceneConfigId,
      callback: function ($$v) {
        _vm.sceneConfigId = $$v;
      },
      expression: "sceneConfigId"
    }
  }, _vm._l(_vm.plainOptions, function (item) {
    return _c("a-checkbox", {
      key: item.value,
      attrs: {
        value: item.value,
        disabled: item.disabled
      }
    }, [_vm._v(_vm._s(_vm.$t(item.label)))]);
  }), 1)], 1)], 1)], 1), _vm.sceneConfigId.indexOf("INTERNAL_MAIL") !== -1 ? _c("div", {
    staticClass: "template-card"
  }, [_c("p", {
    staticClass: "template-title"
  }, [_vm._v(_vm._s(_vm.$t("站内信")))]), _c("a-dropdown", {
    scopedSlots: _vm._u([{
      key: "overlay",
      fn: function () {
        return [_c("a-menu", _vm._l(_vm.internalMailSceneList, function (item) {
          return _c("a-menu-item", {
            key: item.language + "INTERNAL_MAIL",
            on: {
              click: function ($event) {
                return _vm.useTemplate(item, "internalMail");
              }
            }
          }, [_c("span", [_vm._v(_vm._s(_vm.$t(item.languageTitle)))])]);
        }), 1)];
      },
      proxy: true
    }], null, false, 2501046126)
  }, [_c("a-button", {
    staticClass: "marginL15",
    attrs: {
      type: "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t("使用系统模板")))])], 1), _c("div", {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c("mail", {
    ref: "internalMailForm",
    attrs: {
      item: _vm.internalMailSceneObj,
      scenc: "INTERNAL_MAIL",
      attachmentVariable: _vm.attachmentVariable,
      variables: _vm.variables
    }
  }), _c("variable", {
    staticStyle: {
      width: "30%",
      "margin-left": "50px"
    },
    attrs: {
      scenc: "INTERNAL_MAIL",
      variables: _vm.variables
    }
  })], 1)], 1) : _vm._e(), _vm.sceneConfigId.indexOf("NOTE") !== -1 ? _c("div", {
    staticClass: "template-card"
  }, [_c("p", {
    staticClass: "template-title"
  }, [_vm._v(_vm._s(_vm.$t("短信")))]), _c("a-dropdown", {
    scopedSlots: _vm._u([{
      key: "overlay",
      fn: function () {
        return [_c("a-menu", _vm._l(_vm.noteSceneList, function (item) {
          return _c("a-menu-item", {
            key: item.language + "note",
            on: {
              click: function ($event) {
                return _vm.useTemplate(item, "note");
              }
            }
          }, [_c("span", [_vm._v(_vm._s(_vm.$t(item.languageTitle)))])]);
        }), 1)];
      },
      proxy: true
    }], null, false, 918561583)
  }, [_c("a-button", {
    staticClass: "marginL15",
    attrs: {
      type: "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t("使用系统模板")))])], 1), _c("div", {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c("message", {
    ref: "noteForm",
    attrs: {
      item: _vm.noteSceneObj,
      attachmentVariable: _vm.attachmentVariable,
      allMessageList: _vm.messageLists,
      variables: _vm.variables
    }
  }), _c("variable", {
    staticStyle: {
      width: "30%",
      "margin-left": "50px"
    },
    attrs: {
      variables: _vm.variables
    }
  })], 1)], 1) : _vm._e(), _vm.sceneConfigId.indexOf("EMAIL") !== -1 ? _c("div", {
    staticClass: "template-card"
  }, [_c("p", {
    staticClass: "template-title"
  }, [_vm._v(_vm._s(_vm.$t("邮箱")))]), _c("a-dropdown", {
    scopedSlots: _vm._u([{
      key: "overlay",
      fn: function () {
        return [_c("a-menu", _vm._l(_vm.emailSceneList, function (item) {
          return _c("a-menu-item", {
            key: item.language + "EMAIL",
            on: {
              click: function ($event) {
                return _vm.useTemplate(item, "email");
              }
            }
          }, [_c("span", [_vm._v(_vm._s(_vm.$t(item.languageTitle)))])]);
        }), 1)];
      },
      proxy: true
    }], null, false, 1823047667)
  }, [_c("a-button", {
    staticClass: "marginL15",
    attrs: {
      type: "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t("使用系统模板")))])], 1), _c("div", {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c("email", {
    ref: "emailForm",
    attrs: {
      item: _vm.emailSceneObj,
      attachmentVariable: _vm.attachmentVariable,
      variables: _vm.variables
    }
  }), _c("variable", {
    staticStyle: {
      width: "30%",
      "margin-left": "50px"
    },
    attrs: {
      variables: _vm.variables
    }
  })], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm.sceneConfigId.length > 0 && _vm.form.pushScenario ? _c("div", {
    staticClass: "save-btn",
    staticStyle: {
      width: "100%",
      "text-align": "center"
    }
  }, [_c("a-button", {
    attrs: {
      type: "primary",
      loading: _vm.saveLoading
    },
    on: {
      click: _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t("保存")))])], 1) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };